export default {
  queryAllAgents: '查询所有服务商',
  queryAllOperators: '查询所有运营',
  productSalesRanking: '产品销量排行',
  deviceAnalysis: '设备分析',
  revenueReport: '营收报表',
  getDailyData: '获取日数据',
  actualAmount: '实际金额',
  refundAmount: '退款金额',
  salesRevenue: '销售收入',
  processCurrentDevice: '处理当前设备',
  processCurrentDate: '处理当前选择日期',
  date: '日期',
  amount: '金额',
  yuan: '元',
  all: '全部',
  accountInfo: '账户信息',
  salesRanking: '销售排行',
  deviceSalesReport: '设备销售报表',
  selectedDateRangeError: '您选择的日期范围不可大于',
  days: '天',
  contactPlatformForMoreData: '如需要更多数据请联系平台',
  selectDevice: '请选择设备',
  serialNumber: '流水号',
  createTime: '创建时间',
  selectAgent: '选择服务商',
  replaceLifecycle: '代替生命周期',
  todayTransactionAmount: '今日交易额',
  orderQuantity: '订单量',
  yesterdayTransactionAmount: '昨日交易额',
  thisMonthTransactionAmount: '本月交易额',
  historicalTransactionAmount: '历史交易额',
  recent: '最近',
  dailyVisitors: '日访问人数',
  visitors: '访问人数',
  recentTransactions: '最近交易记录',
  moreTransactions: '更多交易',
  todayTransactions: '今日交易',
  transactionAmount: '交易金额',
  orderCount: '订单笔数',
  pen: '笔',
  turnover: '成交额',
  averagePrice: '笔单价',
  yesterdayIncomeAndExpense: '昨日收支',
  yesterdayTurnover: '昨日成交金额',
  yesterdayRefundAmount: '昨日退款金额',
  refundCount: '退款笔数',
  accountIncomeAmount: '账户收入金额',
  incomeCount: '收入笔数',
  accountExpenseAmount: '账户支出金额',
  expenseCount: '支出笔数',
  getPersonalInfo: '获取个人信息',
  noNotificationsToHandle: '暂时没有需要处理的通知',
  viewMore: '查看更多',
  hello: '您好',
  loginAccount: '登录账号',
  availableBalance: '账户可用余额',
  unavailableBalance: '不可用余额',
  unavailableBalanceDesc: '不可用余额是指用户本人账户中暂时不能使用的那部分资金',
  confirmExport: '您确认导出',
  year: '年',
  month: '月',
  day: '日',
  to: '到',
  data: '数据',
  businessDataAnalysis: '经营数据分析',
  dataExport: '数据导出',
  selectOperator: '选择运营商',
  transactionCount: '交易笔数',
  salesDataAnalysis: '销售数据分析',
  commodityDataAnalysis: '商品数据分析',
  queryPointAgents: '查询点位代理商',
  noParam: '不传',
  queryAll: '查全部',
  deviceQueryWithPagination: '带分页信息的设备查询',
  messageType: '消息类型',
  batchMarkAsUnread: '批量更新为未读',
  batchMarkAsRead: '批量更新为已读',
  batchDelete: '批量删除',
  currentSelectedMessages: '当前选中的消息列表',
  saveCurrentState: '储存当前状态',
  storeState: '存储状态',
  deleteMessage: '删除消息',
  confirmDeleteMessage: '确定删除该消息吗',
  confirm: '确定',
  cancel: '取消',
  modifyState: '修改状态',
  unknownType: '未知类型',
  handle: '点击去处理',
  handleRefund: '点击去处理退款',
  handleNewDevice: '点击去处理新设备',
  handleCommodity: '点击去处理商品',
  batchOperationButton: '批量操作按钮',
  noMessagesSelected: '您还没有勾选消息',
  filterSelectedMessages: '筛选出选中的消息项',
  operationFailed: '操作失败',
  publishDate: '发布日期',
  modifyReadState: '修改已读状态',
  status: '状态',
  title: '标题',
  markSelectedAsRead: '标记勾选为已读',
  markSelectedAsUnread: '标记勾选为未读',
  batchOperations: '批量操作',
  new: '新建',
  updateSuccess: '更新成功',
  callApiValue: '调用接口的值',
  callApi: '调用接口',
  form: '表单的',
  componentGridFormat: '组件的栅格化格式',
  changePassword: '修改密码',
  originalPassword: '原密码',
  enterOriginalPassword: '请输入原密码',
  newPassword_PH: '请输入新密码',
  calculateRowsAndColumns: '计算需要多少行多少列',
  getImageDimensions: '获取原始图片的宽度和高度',
  calculateDrawDimensions: '计算绘制到上时的目标宽度和高度',
  keepRatio: '保持比例',
  calculateImagePosition: '计算图片在中居中显示的位置',
  refresh: '刷新',
  clearData: '清除数据',
  clickToComposeImage: '点击合成图片',
  browserNotSupport: '您的浏览器暂不支持',
  tag: '标签',
  serviceFee: '手续费',
  isLoading: '是否在加载',
  search: '搜索',
  create: '创建',
  setupSuccess: '设置成功',
  modifyCommodityApi: '修改商品接口',
  serviceFeeManagement: '手续费管理',
  enterServiceFeeRatio: '请输入手续费比例',
  submit: '提交',
  createApi: '创建接口',
  searchApi: '查询接口',
  lessThan: '小于',
  price: '价格',
  startTime: '开始时间',
  endTime: '结束时间',
  store: '店铺',
  controlDatePicker: '控制日期选择器',
  dailyOrderQuantity: '日订单量',
  dailyFootfall: '日人流量',
  salesVolume: '销售额',
  footfall: '人流量',
  orderQuantityComparison: '订单量对比',
  merge: '合并',
  duplicateDishData: '中重复菜品的数据',
  duplicateCommodityData: '为合并中重复商品的数据的',
  sortBy: '按照排序',
  addSerialNumberToSalesRanking: '为销售额排行榜数据添加序号',
  totalSalesTrendChart: '销售总额趋势图',
  barColor: '柱子颜色',
  overallShadowColor: '整体阴影颜色',
  includingEdges: '包括边缘',
  shadowOpacity: '阴影的透明度',
  barColorOpacity: '柱子颜色透明度',
  currentBalance: '当前余额',
  frozenAmount: '冻结金额',
  viewDeviceInventory: '查看设备库存',
  export: '导出',
  inventoryQuantity: '库存数量',
  noData: '暂无数据',
  convertToTableObject: '通过工具将转表对象',
  sort: '排序',
  note: '注',
  startFrom: '必须从开始',
  defineString: '这个是定义一个字符串',
  tableRange: '也就是表的范围',
  defineOperationDocument: '定义操作文档',
  currentInventory: '当前库存',
  defineTableName: '定义表明',
  tableObject: '表对象',
  noteTableName: '注意表明',
  inventory: '库存',
  writeDataToFile: '将数据写入文件',
  exportedDataCount: '共导出条数据',
  device: '设备',
  kind: '种商品',
  piece: '件',
  unknownCommodity: '未知商品',
  noDeviceInventoryInfo: '暂无设备库存信息',
  listData: '列表数据',
  modifyAndSubmit: '修改提交',
  callVisionCabinetApi: '调用视觉柜的接口',
  modifySuccess: '修改成功',
  createDeviceInfo: '创建设备信息',
  enterDeviceName: '请输入设备名称',
  selectDeviceStatus: '请选择设备状态',
  address: '地址',
  enterAddress: '请输入地址',
  inventoryAlarmType: '库存报警类型',
  selectAlarmType: '请选择报警类型',
  alarmByStockoutQuantity: '按缺货数量报警',
  alarmByRemainingStockPercentage: '按剩余总库存百分比报警',
  alarmValue: '报警数值',
  enterValue: '请输入数值',
  whenDeviceTypeIsVisionCabinet: '设备类型为视觉柜时',
  hide: '隐藏掉',
  deliveryRule: '配送规则',
  recognitionModel: '识别模型',
  autoUpdate: '是否自动更新',
  selectDeliveryRule: '请选择配送规则',
  enterModel: '请输入模型',
  getList: '获取列表',
  forcedOpenMethod: '强制开门开法',
  forcedRestartMethod: '强制重启方法',
  initializationMethod: '初始化方法',
  clickForcedOpenButton: '点击强制开门按钮',
  confirmForcedOpen: '确认强制打开',
  clickForcedRestartButton: '点击强制重启按钮',
  confirmForcedRestart: '确认强制重启',
  updateDeviceOnlineStatus: '更新设备在线状态',
  deviceUpdateOnlineStatus: '设备更新在线状态',
  paginationChange: '分页改变则调用',
  requery: '重新查询',
  downloadQrCode: '下载二维码',
  setDownloadFileName: '设置下载的文件名',
  default: '默认是',
  downloadAfterDeleteElement: '下载之后把创建的元素删除',
  clickInitializeButton: '点击初始化按钮',
  confirmInitialize: '确认初始化',
  restart: '重启',
  method: '的方法',
  for: '为的设备',
  restartFunction: '重启功能',
  button: '按钮',
  confirmRestart: '确认重启',
  exportDeviceList: '导出设备列表',
  version: '版本',
  type: '类型',
  network: '网络',
  purchaseTime: '购买时间',
  commodityDetails: '商品明细',
  deviceToBeActivated: '设备待激活',
  edit: '编辑',
  insertItemAt: '插入一项在的位置',
  iotCardNumber: '物联卡号',
  enable: '启用',
  disable: '禁用',
  viewQrCode: '查看二维码',
  viewCurrentInventory: '查看当前库存',
  initializeDevice: '初始化设备',
  getOnlineStatus: '获取在线状态',
  increaseVolume: '增加音量',
  decreaseVolume: '减少音量',
  exportAllDevices: '导出全部设备',
  updateDeviceStatus: '更新设备状态',
  queryAllModels: '查询所有模型',
  updateDeviceInfo: '更新设备信息',
  viewDeviceImagesWithPagination: '分页查看设备图集',
  updateVisionCabinetInfo: '更新视觉柜设备信息',
  forcedReboot: '强制重启',
  operationButtonsVisibility: '上方的操作按钮是否可见',
  filteredListData: '条件搜索后的列表数据',
  whenFilterConditionsEmpty: '筛选商品条件都为空时',
  executeOnce: '执行一次',
  queryAllItems: '查询所有',
  getInfoList: '获取信息列表',
  dragStart: '拖拽开始',
  dragDrop: '拖拽元素放到放置元素',
  prompt: '提示',
  mobileNotSupportModify: '手机端暂不支持修改',
  save: '保存',
  barcode: '条形码',
  remove: '移除',
  noConfiguredCommodity: '未配置商品',
  originalPriceAndDiscountPriceDisplay: '原价和折后价显示',
  originalPrice: '原价',
  discountPrice: '折后价',
  whenNotEqual: '当和不相等时',
  displayBothPrices: '显示折后价和原价',
  whenEqual: '当和相等时',
  displayOriginalPriceOnly: '只显示原价',
  noConfigurationOnThisLayer: '本层未配置',
  deviceNotBoundType: '设备未绑定类型',
  numberOfLayers: '放几层',
  itemsPerLayer: '每层放几个',
  position: '位置',
  itemsOnPosition: '上有什么物品',
  format: '格式化',
  layer: '层',
  addPerLayer: '每层加个',
  commoditiesInDevice: '设备里放何种商品',
  getCommodityInfoError: '获取商品信息出错',
  remainingQuantity: '商品剩余数量',
  commodityPositions: '商品放在那些位置',
  eachPositionDetails: '每个位置上的商品详情',
  addProductToEachLayer: '把产品添加到每层',
  removeDuplicates: '去重',
  addProductToPosition: '把产品添加到位置',
  submittedData: '提交的数据',
  modifyCommodity: '修改商品',
  deviceNumber: '设备号',
  getLeftList: '获取左侧列表',
  viewDeviceWithPagination: '分页查看设备',
  modifyDeviceGoodsInfo: '修改设备货物信息',
  outstockQuantity: '缺货数量',
  outstockListDetails: '缺货清单详情',
  unusedComponent: '没用到的组件',
  totalPrice: '总价',
  exportMultipleDevicesInventory: '导出多个设备的商品库存数据',
  selectDevices: '请选择设备',
  maximumDevices: '最多选择个设备',
  allCommoditiesQuantity: '设备所有商品数量',
  deviceInventory: '设备库存',
  viewInventory: '查看库存',
  batchExportDeviceInventory: '批量导出设备库存',
  getCommodityInventoryInAllDevices: '获取某个商品在所有设备的库存情况',
  inventoryStatus: '库存情况',
  totalCommodityInventory: '商品总库存',
  viewCommodityInventoryInDevices: '查看商品在各个设备中的库存情况',
  view: '查看',
  deviceInventoryWithPagination: '带分页信息的设备库存',
  statisticsUnderOperator: '统计运营商或子运营商名下',
  eachDeviceRemainingCommodities: '每个设备的当前剩余商品的总数',
  displayFields: '显示字段为',
  currentTotalCommodities: '当前商品总数',
  eachCommodityRemainingTotal: '每种商品的当前剩余总数',
  commodityBarcode: '商品条码',
  currentCommodityCount: '当前商品数',
  singleMachineInventoryStatistics: '单台机器总库存留存及剩余库存金额统计',
  totalAmountOfRemainingInventory: '统计设备剩余库存的总金额数',
  sumOfAllAmounts: '库存商品的所有金额总和',
  remainingCommoditiesTotalPrice: '设备剩余商品总价格',
  boxState: '框状态',
  currentlySelected: '当前选中的',
  getLineList: '获取线路列表',
  lineName: '线路名称',
  pointCount: '点位数量',
  deviceCount: '设备数量',
  deleteLine: '删除线路',
  confirmDeleteLine: '确认要删除线路吗',
  delete: '删除',
  add: '添加',
  couponActivityQueryWithPagination: '带分页信息的优惠券活动查询',
  createMethod: '创建方法',
  processingSuccess: '处理成功',
  modifyGroupApi: '修改分组接口',
  enterRouteName: '请输入路线名称',
  enterLineName: '请输入线路名称',
  includedPoints: '包含点位',
  selectIncludedPoints: '请选择包含点位',
  getCouponActivityList: '获取优惠券活动列表',
  pointName: '点位名称',
  belongingLine: '所属线路',
  deletePoint: '删除点位',
  confirmDeletePoint: '确认要删除点位吗',
  devicePointsWithPagination: '带分页信息的设备点位',
  availableDevicesWithPagination: '带分页信息的设备点位的可用设备',
  enableWhenModify: '修改时解除禁用',
  enterPointName: '请输入点位名称',
  includedDevices: '包含设备',
  allDevices: '全部设备',
  availableDevices: '可选设备',
  addCommodity: '添加商品',
  addSuccess: '添加成功',
  noSuchCommodityInLibrary: '商品库中暂无此商品',
  commodityLibraryCount: '商品库已累计个常见商品入库',
  addViaBarcode: '通过条形码添加商品可快捷创建您的商品',
  cannotBeEmpty: '不能为空',
  invalidFormatPrompt: '不符合规则时提示信息',
  enterCommodityBarcode: '请输入商品条形码',
  scanGunRecommendation: '推荐使用扫描枪录入或手动录入准确商品条码',
  continueAdding: '您可以继续输入条形码添加商品',
  createFromCommodityLibrary: '创建商品从商品库',
  queryCommodityLibrary: '查询商品库的信息',
  categoryMustBeSecondary: '分类必须是二级分类',
  modifiedValue: '修改的值',
  applicationSuccess: '申请成功',
  pieceUnit: '件',
  boxUnit: '箱',
  cartonUnit: '盒',
  cupUnit: '杯',
  bottleUnit: '瓶',
  canUnit: '罐',
  bagUnit: '袋',
  pieceUnit2: '支',
  up: '上',
  down: '下',
  left: '左',
  right: '右',
  front: '前',
  back: '后',
  supplement: '补单',
  applyForStorage: '申请入库',
  enterName: '请输入名称',
  selectUnit: '请选择单位',
  selectCommodityUnit: '请选择商品单位',
  suggestedRetailPrice: '建议零售价',
  enterSuggestedPrice: '请输入建议零售价',
  enterPrice: '请输入价钱',
  averageWeight: '平均重量',
  enterAverageWeight: '请输入平均重量',
  gram: '克',
  commodityCategory: '商品分类',
  enterCategory: '请输入商品分类',
  commodityBrand: '商品品牌',
  uploadCommodityImage: '请上传商品图片',
  commodityModeling: '商品建模',
  sizeRequirements: '尺寸要求',
  minimumSumOfDimensions: '商品的长宽高之和不低于',
  minimumEdgeLength: '最短边长度',
  thickness: '厚度',
  greaterThan: '大于',
  modelingImagesRequirements: '建模图片为上下左右前后张',
  simulateCameraAngle: '及模拟摄像头角度拍摄',
  imagesCount: '张图片',
  onSale: '上架',
  offSale: '下架',
  warningInventory: '警告库存',
  soldInventory: '已售库存',
  sellingInventory: '在售库存',
  categoryName: '分类名称',
  commodityPriceCannotBeLessThan: '商品价格不得小于',
  createSuccess: '创建成功',
  changeCommodityImageContactCustomerService: '如需变更商品图片请联系售后客服',
  uploadSuccess: '上传成功',
  refreshData: '刷新数据',
  unrecognizedBarcode: '未识别出条形码',
  templateDownload: '模板下载',
  downloadTemplateFirst: '请先下载模板',
  onlySupportExistingCommodities: '仅支持系统商品库有的商品',
  algorithmPlatformList: '算法平台列表',
  currentSelectedDrawer: '当前选中抽屉的',
  deleteCommodityInfo: '删除商品信息',
  confirmDeleteCommodity: '确定删除吗',
  displayImage: '展示图片',
  syncStatus: '同步状态',
  kuangshi: '旷视',
  unreviewed: '未审核',
  passed: '通过',
  failed: '失败',
  getAlgorithmObject: '拿到对应的算法对象',
  underReview: '审核中',
  rejected: '未通过',
  commodityName: '商品名称',
  yuanUnit: '元',
  pieceCount: '个',
  belongingClassification: '所属分类',
  belongingBrand: '所属品牌',
  yuncongReviewStatus: '云从审核状态',
  yuncongRejectionReason: '云从拒绝信息',
  details: '详情',
  supplementaryImage: '补充图',
  noImage: '暂无图片',
  applyForStock: '申请入库',
  batchImportCommodities: '批量导入商品',
  commodityQueryWithPagination: '带分页信息的商品查询',
  underAudit: '正在审核',
  createOrModifyCommodity: '创建或修改商品信息',
  currentSelected: '当前选中的',
  confirmDeleteIn: '确定删除中吗',
  appliedDevices: '应用设备',
  commodityPrice: '商品价格',
  modifyCommodityPriceInfo: '修改商品价格信息',
  createCommodityPriceInfo: '创建商品价格信息',
  selectCommodityLibrary: '请选择商品库',
  selectAppliedDevices: '请选择应用设备',
  syncCommodityLibrary: '同步商品库',
  addToPrivateLibrary: '添加到私库',
  addToPersonalLibrary: '添加到个人商品库',
  confirmAddToPersonalLibrary: '确定要将添加到个人商品库吗',
  printLog: '打印一下日志',
  yuncongAlgorithm: '云从算法',
  alipay: '支付宝',
  syncFailed: '未同步成功',
  syncSuccess: '成功',
  refuseSync: '拒绝同步',
  retailPrice: '零售价',
  standardWeight: '标品重量',
  available: '可用',
  disabled: '不启用',
  unit: '单位',
  alreadyAddedToPrivateLibrary: '已添加到私库',
  deleteCommodityLibrary: '删除商品库',
  createModifyCommodityLibrary: '创建修改商品库',
  addCommodityToPrivateLibrary: '商品添加到私库',
  confirmReturn: '确认退回吗',
  commodityStockIn: '商品入库',
  modelingUpdate: '建模更新',
  pendingReview: '待审核',
  applicationTime: '申请时间',
  modify: '修改',
  multiPackagingAudit: '申请多包装',
  showPopup: '是否显示弹窗',
  confirmButton: '确认按钮',
  applyForMultiPackaging: '根据申请多包装',
  popupComponent: '弹窗组件',
  applicationSubmittedSuccessfully: '申请提交成功',
  applyForMultiCommodityPackage: '申请多商品套餐',
  commodityDescription: '商品描述',
  commodityImage: '商品图片',
  enterCommodityName: '请输入商品名称',
  enterDescription: '请输入商品描述',
  enterCommodityPrice: '请输入商品价格',
  commodityNumber: '商品编号',
  enterCommodityNumber: '请输入商品编号',
  ifHasQueryResults: '如果有查询结果',
  setAuditFormInitialValueToReject: '设置审核表单的初始值为拒绝',
  reject: '拒绝',
  ifNoQueryResults: '如果没有查询结果',
  getImageListDirectly: '直接获取图片列表',
  auditPassed: '审核通过',
  addSearchParameters: '添加搜索参数',
  getCorrespondingImages: '拿到对应的图片',
  submitAudit: '提交审核',
  selectCommodityImage: '请选择商品图',
  synthesizeMainImage: '请合成商品主图',
  confirmSubmitAudit: '确定提交审核吗',
  cannotModifyAfterSubmission: '提交后将无法修改',
  ifSynthesizedImageExists: '若已有合成图',
  showPrompt: '显示提示',
  promptMessage: '提示',
  clearSynthesizedImage: '继续选择将清除已合成的图片',
  continue: '是否继续',
  clearAndSelect: '清除合成图片并执行选择',
  cancelSelection: '取消选择操作',
  ifNoSynthesizedImage: '如果没有合成图片',
  executeSelectionDirectly: '直接执行选择',
  preventEventBubbling: '阻止事件冒泡',
  avoidTriggeringSelection: '避免触发选择事件',
  deleteCommodityFromLibrary: '删除商品库商品',
  confirmDeleteItem: '确定删除吗',
  deleteSuccess: '删除成功',
  getAllSelectedImages: '获取所有选中图片的',
  filterPossibles: '过滤掉可能的',
  assertAs: '并断言为',
  synthesizedImageCancelled: '合成图片已取消',
  getImages: '获取图片',
  uploadFailed: '上传失败',
  onlyImageFilesAllowed: '只能上传图片文件',
  imageMustBeLessThan: '图片必须小于',
  auditStatus: '审核状态',
  selectAuditStatus: '请选择审核状态',
  auditPass: '审核通过',
  auditMessage: '审核消息',
  enterAuditMessage: '请输入审核消息',
  hasModelingImages: '有建模图',
  selected: '已选择',
  clickToUpload: '请点击上传',
  uploading: '上传中',
  upload: '上传',
  synthesize: '合成',
  mainImage: '主图',
  audit: '审核',
  auditPage: '审核页面',
  viewApplicationRecords: '查看申请记录',
  mainProductNumber: '主产品号',
  applicationStatus: '状态',
  inApplication: '申请中',
  applicationApproved: '申请通过',
  applicationRejected: '申请拒绝',
  modificationTime: '修改时间',
  multiPackagingAuditList: '多包装审核列表',
  imageCuttingApi: '抠图接口',
  synthesizeImage: '合成图片',
  synthesizeImageParameters: '合成图片参数',
  cancelRequestSignal: '取消请求信号',
  imageResultUrl: '图片结果网络地址',
  auditMultiPackaging: '审核多包装',
  getUploadUrl: '获取上传地址',
  multiPackagingQueryWithPagination: '带分页信息的查询',
  createCommodityFromLibrary: '创建商品从商品库',
  creationTime: '创建时间',
  customerPhone: '客户手机号',
  paymentMethod: '支付方式',
  wechatFreePayment: '微信免密',
  paymentPoints: '支付分',
  shoufutong: '收付通',
  shoufutongFace: '收付通刷脸',
  alipayFace: '支付宝刷脸',
  alipayNFC: '支付宝NFC',
  other: '其他',
  processingInstructions: '处理说明',
  getItemList: '获取列表',
  selectCommodity: '请选择商品',
  orderAmount: '订单金额',
  noConsumptionInThisOrder: '本单未产生消费',
  modifyOrderSettlement: '修改订单明细结算',
  maliciousBehaviorFine: '恶意行为罚款',
  processingResult: '处理结果',
  abnormalOrderProcessing: '异常订单处理',
  processingTime: '处理时间',
  noSuchCommodityFound: '没有找到该商品',
  thumbnail: '缩略图',
  actualSellingPrice: '实际售价',
  quantity: '数量',
  punishOrderItem: '恶意行为罚款',
  fineAmount: '罚款金额',
  twoWayBinding: '表单数据的双向绑定',
  differentialVideo: '差分视频',
  orderVideo: '订单视频',
  secondaryCameraVideo: '副相机视频',
  currentOrderRecognitionResult: '当前订单识别结果',
  orderProcessingResult: '订单处理结果',
  selectOrderProcessingResult: '请选择订单处理结果',
  processingOpinions: '处理意见',
  orderDetailsSettlement: '订单明细结算',
  punishAmount: '处罚金额',
  enterPunishAmount: '请输入处罚金额',
  phoneNumber: '手机号',
  clickProcessOrderButton: '点击处理订单按钮时',
  ifVisionOrder: '如果此订单是视觉的',
  callAlipayVisionHandler: '就调用处理支付宝视觉异常订单的',
  judgeByMarker: '是通过标记来判断',
  processOrder: '处理订单',
  unitPrice: '单价',
  nonFriendlyShopping: '非友好购物',
  unknownProduct: '未知商品',
  accuracy: '精确度',
  pleaseSelect: '请选择',
  abnormalData: '异常数据',
  processingCompleted: '处理完成',
  handlingAbnormalOrder: '处理异常订单',
  processingResultStatus: '处理结果状态',
  unprocessed: '未处理',
  processed: '已处理',
  viewDeviceTypesWithPagination: '分页查看设备类型',
  queryAlipayCommodityList: '查询支付宝的商品列表',
  handlePaymentMethodAbnormalOrder: '支付方式的异常订单',
  editTable: '编辑表格',
  popupVisibility: '弹窗是否可见',
  openStatus: '打开状态',
  currentModelingImage: '当前的图片建模图',
  currentImageData: '当前图片的数据',
  video: '视频',
  imageComponent: '图片组件',
  array: '数组',
  commodityLibraryList: '商品库列表',
  filteredList: '筛选列表',
  pageSetup: '进入页面设置',
  orderProcessed: '订单已处理',
  accordingToAddressBar: '根据地址栏',
  parameterSetup: '参数设置',
  defaultVideo: '拿到了默认显示的视频是还是',
  setVideoSpeed: '设置默认显示的视频的视频速度',
  focusOn: '焦点在上',
  pressToControlPlayback: '按下控制视频播放',
  selectedProcessingType: '选择的处理类型',
  pleaseSelectCommodity: '请选择商品',
  processingFailed: '处理失败',
  slowDownButton: '减速按钮',
  whenOperatingQuantityInComponent: '在组件中操作数量时',
  linkQuantityInImageComponent: '联动图片组件中的数量',
  findCommodityImageComponent: '通过列表和索引找到商品图片组件',
  resetDataInComponent: '然后重置其中的数据',
  whenEnteringChinese: '正在输入中文时',
  initialization: '初始化',
  abnormalOrderAudit: '异常订单审核',
  videoSection: '视频部分',
  mainCameraVideo: '主相机视频',
  slowDown: '减速',
  leftSelectedCommodities: '左侧已经选择商品的',
  confirmSubmitOrder: '确认提交订单',
  confirmSubmission: '是否确认',
  disableWhenProcessed: '已处理就禁用',
  nonFriendlyPurchase: '非友好购物',
  enterProcessingOpinions: '输入处理意见',
  processingOpinionsField: '处理意见',
  abnormalType: '异常类型',
  enterAmount: '请输入金额',
  clickImageToViewModeling: '点击图片可查看商品各个方向建模图',
  clickToSelectCommodity: '点击商品对应加减号可选择商品',
  modalComponent: '模态框组件',
  noModelingImage: '该商品暂无建模图',
  clickPlusMinusCallback: '点击加减的回调',
  bindAddCommodityEvent: '绑定添加商品事件',
  localStorage: '与本地存储',
  selectedCommodityList: '存储的是已经选好的商品列表',
  mergeMatches: '做匹配合并',
  addArray: '添加数组',
  selectedDeviceOrLineOrPoint: '选中的是设备还是线路还是点位',
  finallySelectedDevices: '最终选择的设备列表',
  lineList: '线路列表',
  pointList: '点位列表',
  salesStatisticsData: '销量统计数据',
  operator: '操作人员',
  transactionCategory: '交易类目',
  orderStatistics: '订单统计',
  discountAmount: '优惠金额',
  algorithmPrice: '算法价格',
  salesQuantity: '销售数量',
  refundQuantity: '退款数量',
  queryAllDevicesSales: '查询所有设备的销售信息',
  collateData: '整理数据',
  accumulateTotalData: '累加合计数据',
  averageCustomerPrice: '客单价',
  exportAllCommoditySales: '导出全部商品的销量数据',
  triggerValidationManually: '手动触发验证',
  total: '合计',
  deviceName: '设备名称',
  deviceSales: '设备销量',
  deviceCheckboxChangeCallback: '设备多选框改变的回调函数',
  selectedDeviceList: '选择的设备列表',
  selectionTypeChange: '选择类型改变',
  selectedLineCallback: '选中线路的回调',
  deviceArray: '数组',
  pleaseWait: '请稍等',
  selectedPointCallback: '选中点位的回调',
  totalSales: '合计销售额',
  totalRefund: '退款总',
  totalDiscount: '优惠金额',
  totalAlgorithmPrice: '算法价格',
  totalSalesQuantity: '销售数量',
  totalRefundQuantity: '退款数量',
  quickSelection: '快速选择',
  byDevice: '按设备',
  byLine: '按线路',
  byPoint: '按点位',
  pointSelection: '点位选择',
  selectPoint: '请选择点位',
  quickSelectByPoint: '通过点位快捷选择设备',
  lineSelection: '线路选择',
  selectLine: '请选择线路',
  quickSelectByLine: '通过线路快捷选择设备',
  selectWhichDevices: '选择哪几个设备',
  querySelectedDevices: '查询的就是哪几个',
  whenNoSelection: '没有选择时',
  queryAllDevices: '查询的是全部的设备',
  queryDeviceDetails: '您可以在选中想要查询的设备后在右侧表格中查询某个设备的详细销售情况',
  dateRange: '日期范围',
  selectTimeRange: '请选择时间范围',
  yesterday: '昨天',
  lastMonth: '上月',
  setToCurrentMonth: '设置事件为本月',
  currentMonth: '本月',
  queryOrderSalesQuantity: '查询订单销售数量',
  queryCommoditySalesQuantity: '查询商品销售数量',
  queryDeviceSales: '查询设备销量',
  exportSalesData: '导出销量数据',
  allSales: '全部销量',
  nonRealTimeData: '此数据井非实时数据',
  updateEveryHour: '每个小时的分更新一次数据',
  forExample: '如',
  updateTime: '更新时间',
  dataBeforeTime: '点之前的所有数据',
  buttonLoadingState: '按钮加载状态',
  fileList: '文件列表',
  clickedRecordData: '点击的记录数据',
  queryType: '查询类型',
  judgeExportType: '根据判断导出的是设备订单还是订单',
  ifExportTaskExists: '存在正在导出的任务',
  pollingQuery: '则轮询查询',
  fileName: '文件名',
  category: '类别',
  deviceOrderSalesQuantity: '设备订单销售数量',
  deviceCommoditySalesQuantity: '设备商品销售数量',
  commoditySalesQuantity: '商品销售数量',
  exportTime: '导出时间',
  beingExported: '正在导出',
  exportSuccessful: '导出成功',
  exportFailed: '导出失败',
  progress: '进度',
  download: '下载',
  orderDetails: '订单详情',
  linePointDeviceList: '线路点位设备列表',
  formSubcomponent: '表单子组件',
  createQueryTask: '创建查询任务',
  createOrderDetailExportTask: '创建订单详情导出任务',
  exportedData: '导出的数据',
  commodityUnitPrice: '商品单价',
  salesAmount: '销售额',
  returnQuantity: '退货数量',
  totalSalesCount: '销售数量',
  totalReturnCount: '退款数量',
  queryAllCommoditySales: '查询全部商品销量',
  exportAllSalesData: '导出全部销量数据',
  displayStatus: '显示状态',
  detailList: '详情列表',
  detailSourceData: '详情源数据',
  supplementRefundAmount: '补单退款金额',
  calculateTotal: '计算合计',
  notUsed: '非用到的',
  differentFieldsByType: '后端根据不同类型返回的字段不同',
  used: '已使用',
  supplementRefundCount: '补单退款笔数',
  totalSalesAmount: '总销售额',
  totalCommodityQuantity: '销售商品总数量',
  totalCommodityRefundAmount: '商品总退款金额',
  totalCommodityRefundCount: '商品总退款笔数',
  excludingSupplementRefund: '此处不包含补单退款',
  totalRefundAmount: '商品总退款金额',
  totalDiscountAmount: '总优惠金额',
  totalAlgorithmFee: '算法费总计',
  salesOrderCount: '销售订单笔数',
  commodityRefundCount: '商品退款笔数',
  totalSupplementRefundAmount: '补单退款总金额',
  actualSalesAmount: '实售金额',
  commodityRefundAmount: '商品退款金额',
  salesOrderQuantity: '销售订单数量',
  salesOrder: '销售订单',
  commodityQuantity: '商品数量',
  commoditySalesStatistics: '商品销售统计',
  deviceSalesStatistics: '设备销售统计',
  salesStatistics: '销售统计',
  queryManagedDevices: '查询管理的设备',
  viewCommoditySalesDetails: '商品销售统计查看详情',
  viewDetails: '查看详情',
  commoditySalesVolume: '商品销量',
  deviceSalesDetails: '设备销售详情',
  createExportSalesTask: '创建导出销量数据任务',
  queryTaskList: '查询任务列表',
  consumer: '消费者',
  addBlacklistMethod: '添加黑名单方法',
  addToBlacklist: '加入黑名单',
  confirmAddToBlacklist: '确认加入黑名单',
  attention: '注意',
  cannotPurchaseAfterBlacklist: '将消费者加入黑名单后该消费者将无法进行购买商品',
  enterReason: '请输入原因',
  showExportPopup: '是否显示导出弹窗',
  cancelCallback: '取消的回调',
  exportCallback: '导出的回调方法',
  box: '框',
  confirmButtonState: '确定按钮的状态',
  dateInterval: '日期间隔',
  lastSevenDays: '近七天',
  paymentMethods: '支付方式',
  revenueAndExpenseType: '收支类型',
  wechat: '微信',
  selectPaymentMethod: '请选择支付方式',
  selectRevenueAndExpenseType: '请选择收支类型',
  income: '收入',
  expense: '支出',
  callExportMethod: '调用导出方法',
  verifyForm: '验证表单',
  callInterface: '调接口',
  successPrompt: '成功提示',
  cancelOrderSuccess: '取消订单成功',
  close: '关闭',
  resetSimultaneously: '同时重置',
  closeConfirmButton: '关闭确定按钮的',
  searchFormItems: '搜索表单项',
  phone: '手机号',
  alipayUser: '支付宝用户',
  wechatUser: '微信',
  column: '列',
  orderNumber: '订单号',
  isAbnormalOrder: '是否异常单',
  abnormalOrder: '异常单',
  normalOrder: '正常单',
  orderTime: '下单时间',
  creationDate: '创建日期',
  orderStatus: '订单状态',
  recognitionMethod: '识别方式',
  algorithmRecognition: '算法识别',
  manualRecognition: '人工识别',
  operatorProcessing: '运营商处理',
  remarks: '备注',
  compensationStatus: '赔付状态',
  compensated: '已赔付',
  notCompensated: '未赔付',
  urgePayment: '催收',
  urgeOrder: '催收订单',
  confirmUrgeOrder: '确定催收订单吗',
  urgeSuccess: '催收成功',
  compensationSwitch: '赔付开关',
  reset: '重置',
  table: '表',
  cancelReason: '取消原因',
  temporarilyAdd: '暂时添加',
  alipayWechat: '支付宝微信',
  popup: '弹框',
  orderDetailExport: '订单明细导出',
  auditStatusModal: '算法平台审核状态弹窗',
  algorithmName: '算法名称',
  auditDetails: '审核详情',
  actualCommodityPrice: '商品实际售价',
  individualPrice: '单个商品实际售价',
  displayUse: '界面显示使用',
  openRefund: '打开退款',
  noSelectedRefundCommodity: '您还没有选择退款的商品',
  selectRefundCommodity: '请选择退款的商品',
  setBlacklist: '设置黑名单',
  priceBeforeDiscount: '折扣前单价',
  priceAfterDiscount: '折扣后的单价',
  totalPurchased: '购买总数',
  actualTotalPrice: '实付总价',
  refundProcessing: '退款处理',
  totalRefundPrice: '退款总价',
  commodityList: '商品列表',
  submitRefund: '提交退款',
  refundAmountMustBeGreaterThan: '退款金额必须大于',
  calculateTotalRefund: '计算退款总金额',
  organizeRefundQuantity: '整理退款数量数据',
  unitPriceOfEachCommodity: '每种商品的单价',
  totalPriceOfEachCommodity: '每种商品计算一个总价',
  accumulate: '累加',
  storeFormData: '中存一份表单数据',
  handleCustomerRefund: '处理客户退款',
  modifyPriceAndQuantity: '请修改商品中的价格和数量',
  confirmFinalRefundAmount: '确认最终退款金额',
  itemCount: '个',
  commodityCount: '商品个数',
  enterRefundAmount: '请输入退款金额',
  refundAmountMustBeGreaterThanZero: '退款金额必须大于元',
  enterRemarks: '请输入备注',
  refuseRefundSuccess: '拒绝退款成功',
  refuseRefundReason: '拒绝退款原因',
  enterRefuseReason: '请输入拒绝退款原因',
  querySupplementRecords: '查询补单记录',
  supplementAmount: '补单金额',
  supplementStatus: '补单状态',
  pendingConfirmation: '待确认',
  unpaid: '未支付',
  completed: '已完成',
  supplementing: '补单中',
  supplementCompleted: '补单完成',
  unknown: '未知',
  supplementDescription: '补单说明',
  supplementDate: '补单日期',
  paymentOrderNumber: '支付订单号',
  clickToViewDetails: '点击查看详情',
  supplementOrderNumber: '补单订单号',
  userPhone: '用户手机',
  userInfo: '用户信息',
  deviceId: '设备编号',
  refundedAmount: '已退款金额',
  supplementRemarks: '补单备注',
  supplementTime: '补单时间',
  refund: '退款',
  refundRecords: '退款记录',
  read: '读取',
  addOperatorSearchCondition: '角色服务商添加运营商搜索条件和',
  recursivelyRemove: '递归移除',
  utilityType: '的工具类型',
  exportSwitch: '导出开关',
  revenueExpenseFlag: '收支状态标志',
  totalTransactionCount: '总交易笔数',
  totalActualAmount: '总实际金额',
  totalTransactionAmount: '交易总金额',
  totalOrderAmount: '总订单金额',
  cardStatisticData: '卡片统计数据',
  value: '值',
  totalAmount: '总计金额',
  expenseOrderAmount: '支出订单金额',
  incomeAmount: '收入金额',
  totalIncome: '总计收入',
  calculateEstimatedAmount: '计算预估入账金额',
  algorithmFee: '算法费',
  estimatedIncomingAmount: '预估入账金额',
  expenseOrders: '支出订单',
  penCount: '笔',
  incomeOrders: '收入订单',
  totalServiceFee: '手续费总计',
  wechatTransactions: '微信交易',
  whenNoRevenueExpenseSelected: '未选择收支类型时为支出订单笔数加收入订单笔数',
  whenIncomeSelected: '选择收入时为收入笔数',
  whenExpenseSelected: '选择支出时为支出笔数',
  alipayTransactions: '支付宝',
  sales: '销售额',
  profit: '收益',
  excludingTransactionFee: '除交易手续费',
  rateMinus: '费率减去',
  deductRecognitionFee: '扣除识别算法费',
  totalRefundAmountIncludingFees: '退款总金额',
  includingServiceFee: '含手续费',
  includingRecognitionFee: '含识别算法费',
  actualRateNote: '实际收取比例以微信或支付宝当时的比例为准',
  systemCalculatesWith: '系统统计时以计算',
  estimatedDepositAmount: '预估入账金额',
  paymentAmount: '支付金额',
  time: '时间',
  orderDeductionTime: '订单扣款时间',
  timeSpanCannotExceed: '时间跨度不能超过',
  selectDate: '选择日期',
  transactionBillQueryWithPagination: '带分页信息的交易账单查询',
  transactionBillStatistics: '交易账单统计',
  incomeStatistics: '收入统计信息',
  totalIncomeCount: '总收入笔数',
  totalIncomeAmount: '收入总金额',
  totalServiceFees: '统计总手续费',
  totalAlgorithmFees: '统计总算法费',
  expenseStatistics: '支出统计信息',
  totalRefundCount: '总退款笔数',
  yuncong: '云从',
  statistics: '统计信息',
  totalCount: '总笔数',
  totalSum: '总金额',
  priceSet: '价格是否设置',
  differentTemperatures: '不同温度',
  echo: '回显',
  getUnset: '获取未设置',
  unsetPrice: '未设置价格',
  setPrice: '已设置价格',
  enterBarcodeOrName: '请输入条码或商品名称',
  unifiedPrice: '统一价格',
  strategyName: '策略名称',
  enterStrategyName: '请输入策略名称',
  storeInfoQueryLink: '商店信息查询连接',
  bindingSuccess: '绑定成功',
  bindDevices: '绑定设备',
  getUnboundDevices: '获取未绑定规则的设备列表',
  getAllDevices: '获取所有设备列表',
  unboundDevices: '未绑定设备',
  boundDevices: '已绑定设备',
  unboundStrategyDevices: '未绑定策略的设备列表',
  deletePriceStrategy: '删除价格策略',
  confirmDelete: '确定删除吗',
  whatIs: '是什么',
  importStrategy: '导入策略',
  boundDeviceCount: '绑定设备台数',
  operation: '操作',
  bind: '绑定',
  priceStrategyQuery: '价格策略查询',
  queryBoundStrategiesWithPagination: '分页查询已绑定价格策略',
  modifyPriceStrategy: '修改变动价格策略',
  getAllUnboundDevices: '获取未绑定的策略的所有设备',
  noSelectedCommodities: '您没有选择商品',
  selectedLessThanThreshold: '您选择商品数量小于报警通知阀值',
  modifyRule: '修改规则',
  addRule: '新增规则',
  ruleNameNotFilled: '规则名称未填写',
  enterRuleName: '请输入规则名称',
  selectCommodities: '请选择商品',
  cannotDirectly: '不能直接',
  alarmQuantity: '报警数量',
  alarmQuantityNotFilled: '报警数量未填写',
  enterAlarmQuantity: '请输入报警数量',
  triggerReplenishmentWhenBelow: '当库存商品数量低于报警数量的次数高于报警阀值触发补货通知',
  alarmNotificationThreshold: '报警通知阀值',
  whenAlarmReaches: '当商品报警种类数达到设置值时',
  generateDeliveryOrder: '生成配送单',
  selectStatus: '请选择状态',
  enabled: '启用',
  getRuleInfoList: '获取规则信息列表',
  deleteRule: '删除规则',
  deleteRuleInfo: '删除规则信息',
  confirmDeleteRule: '确定删除吗',
  triggerAlarmQuantity: '触发报警数量',
  boundDeviceQuantity: '绑定设备数量',
  deliveryRulesQueryWithPagination: '带分页信息的配送规则查询',
  addModifyRuleInfo: '新增修改规则信息',
  queryPointsWithPagination: '分页查询点位',
  exportExcel: '导出',
  staff: '人员',
  setToToday: '设置事件为今天',
  setToLastWeek: '设置事件为近一周',
  setToLastMonth: '设置事件为上月',
  cannotSelectFutureDates: '不能选择今天及之后的时间',
  previousInventory: '之前的库存',
  changeQuantity: '变动数量',
  replenishmentDetails: '补货详情',
  getDeliveryOrderList: '获取配送单信息列表',
  noDataInSelectedDate: '选中日期内暂无数据',
  second: '秒',
  actualReplenishmentQuantity: '真实补货数量',
  inventoryRecord: '库存记录',
  exportSuccess: '导出成功',
  returnMergedCellRules: '返回合并单元格的规则',
  stockRecord: '上货记录',
  commodityLeveling: '商品调平',
  shoppingSettlement: '购物结算',
  changeAmount: '变动数量',
  stockTime: '上货时间',
  deviceInfo: '设备信息',
  replenishmentStaff: '补货人员',
  filteredBy: '条件筛选的',
  stockDetailExport: '上货明细导出',
  stockRecords: '上货记录',
  parentComponentUpdateLine: '父组件更新线路',
  childComponentUpdateDevice: '子组件更新默认选中的设备',
  deselectAll: '全不选',
  selectAll: '全选',
  deleteAuthorizedDevice: '删除授权设备',
  deleteAuthorizedDeviceInfo: '删除授权设备信息',
  confirmDeleteDevice: '确定删除吗',
  turnedOn: '开启',
  notTurnedOn: '未开启',
  addAuthorization: '添加授权',
  authorizedDevicesQueryWithPagination: '带分页信息的授设备查询',
  addModifyAuthorizedDevice: '新增修改授权设备信息',
  deleteDeviceAuthorization: '删除设备授权信息',
  authorizeDeviceInfo: '授权设备信息',
  selectStaff: '请选择人员',
  notEnabled: '不启用',
  deleteUserAndAuthorizations: '删除用户并删除授权设备',
  deleteUserInfo: '删除用户信息',
  confirmDeleteUser: '确定删除并解绑名下所有设备吗',
  resetUserSuccess: '重置用户成功',
  name: '名称',
  role: '角色',
  deliveryman: '配货员',
  partnerMerchant: '合伙商家',
  operatorSubmerchant: '运营商子商户',
  resetPassword: '重置密码',
  oneClickCloseAccount: '一键销户',
  oneClickDeleteUser: '一键删除用户',
  deleteAuthorizedDevices: '同时删除授权设备',
  generateRandomPassword: '生成随机密码',
  success: '成功',
  whenAdding: '如果当前是添加操作',
  noValue: '无',
  andNoValue: '并且没有值',
  setAs: '设为',
  judgeOperationType: '根据判断当前是添加还是修改操作',
  timedQuery: '定时查询',
  queryWechat: '查询微信',
  startTimedQuery: '开启定时查询',
  wechatBindingParams: '微信绑定参数',
  originalData: '原数据',
  closeCallback: '关闭的回调',
  modifyStaff: '修改人员',
  createStaff: '创建人员',
  mustBeFullName: '必须是商户全称',
  selectRole: '请选择角色',
  account: '账号',
  enterAccount: '请输入账号',
  password: '密码',
  enterPassword: '请输入密码',
  qrcode: '二维码',
  useAlipayScan: '使用支付宝扫一扫获取',
  noSpacesBetweenNumbers: '数字之间不需要空格隔开',
  enter: '请输入',
  profitSharingType: '分账类型',
  selectProfitSharingType: '请选择分账类型',
  callback: '回调',
  ifSelectedValueIs: '如果选定的值是',
  query: '查询',
  merchantNumber: '商户号',
  useWechatScan: '使用微信扫一扫获取',
  noQrcodeInfo: '暂无二维码信息',
  enterMerchantNumber: '请输入商户号',
  profitSharingPercentage: '分账百分比',
  updatePassword: '修改密码',
  newPassword: '新密码',
  enterNewPassword: '请输入新密码',
  clearQueryTimer: '清空查询定时器',
  'start 定时查询': '开启定时查询',
  submitMethod: '提交方法',
  withdrawalInfoNameMustMatch: '提现信息姓名必须一致',
  cannotChangeAfterSubmission: '提交资料后将无法更改',
  legalPersonName: '法人姓名',
  legalPersonNameNotFilled: '法人姓名未填写',
  enterLegalPersonName: '请填写法人姓名',
  legalPersonIdNumber: '法人身份证号码',
  enterIdNumber: '请填写法人身份证号码',
  enterPhone: '请填写常用电话',
  bindWechatAccount: '绑定微信账号',
  rebind: '重新绑定',
  useLegalPersonWechat: '使用法人的实名认证并绑定银行卡的微信扫码',
  wechatAccountBinding: '微信账号绑定',
  alipayEmailOrPhone: '支付宝使用的邮箱或者手机',
  alipayNameMustMatch: '法人姓名需要和支付宝实名认证一致',
  alipayAccount: '支付宝账号',
  enterAlipayAccount: '请填写提现支付宝账号',
  bankName: '银行卡开户行名称',
  enterBankName: '请填写提现到银行名称',
  bankAccount: '银行卡账号',
  enterBankAccount: '请填写提现到银行卡账号',
  contactCustomerServiceToChange: '如需更改提现资料请联系客服',
  settlementDate: '结算日期',
  actualProfit: '实际收益',
  billStatus: '账单状态',
  noActionNeeded: '无需操作',
  pendingDeposit: '待入账',
  confirmed: '已确认',
  depositing: '入账中',
  deposited: '已入账',
  confirmationTime: '确认时间',
  confirmBill: '确认账单',
  depositTime: '入账时间',
  accountSettlementAmount: '账户结算金额',
  actualSalesRevenue: '实际销售金额',
  friendlyReminder: '温馨提示',
  automaticSettlement: '系统根据流水自动结算',
  everyDayEarlyMorning: '时间为每天凌晨',
  "o'clock": '点',
  settlementCycle: '结算周期为',
  capitalSettlementQueryWithPagination: '带分页信息的资金结算查询',
  modifyInfo: '修改信息',
  changeTime: '变动时间',
  amountFlow: '金额流水',
  frozenFunds: '冻结资金',
  accountWithdrawal: '账户提现',
  accountRecharge: '账户充值',
  unfreezeFunds: '解冻资金',
  profitSettlement: '利润结算',
  changeReason: '变动原因',
  capitalDetailsQueryWithPagination: '带分页信息的资金明细查询',
  withdrawalAmount: '提现金额',
  approved: '已通过',
  withdrawalChannel: '提现渠道',
  applicationRemarks: '申请备注',
  processingRemarks: '处理备注',
  accountBalance: '账户余额',
  wechatCollectionAmount: '微信代收金额',
  alipayCollectionAmount: '支付宝代收金额',
  applyForWithdrawal: '申请提现',
  queryServiceFee: '查询手续费',
  serviceFeeRatio: '手续费比例',
  youHaveNotBoundWithdrawalInfo: '您还没有绑定提现资料',
  cannotInitiateWithdrawal: '无法发起提现',
  enseSettlement: ' 费用结算 ',
  noWithdrawalInfoConfigured: '尚未配置提现资料',
  clickToConfigure: '点击配置',
  explanation: '说明',
  preventUserRefund: '为了防止用户退款时',
  insufficientBalance: '账户中余额不足',
  systemAutomaticallyLocks: '系统自动锁定',
  minimumWithdrawalAmount: '每次提现不得低于',
  enterWithdrawalAmount: '请输入提现金额',
  selectWithdrawalChannel: '请选择提现渠道',
  withdrawalRemarks: '提现备注',
  enterWithdrawalRemarks: '请输入提现备注',
  mimicWindowState: '拟态窗口状态',
  getPointInfoList: '获取点位信息列表',
  deleteCommodity: '删除商品',
  confirmRemoveFromBlacklist: '确认移除黑名单',
  userPhoneNumber: '用户手机号',
  disableReason: '禁用原因',
  disableTime: '禁用时间',
  addBlacklist: '添加黑名单',
  viewUserBlacklistWithPagination: '分页查看用户黑名单',
  createModifyDeviceType: '创建修改设备类型',
  deleteDeviceType: '删除设备类型',
  enterUserPhone: '请输入用户手机号',
  enterDisableReason: '请输入禁用原因',
  getCapitalFlow: '获取资金流水',
  orderID: '订单编号',
  totalCommodityAmount: '商品总额',
  actualPaymentAmount: '实付金额',
  userOrders: '用户订单',
  capitalFlow: '资金流水',
  drawerState: '抽屉状态',
  nickname: '昵称',
  totalOrders: '订单总数',
  commodityPieces: '商品件数',
  viewOrders: '查看订单',
  memberQueryWithPagination: '带分页信息的会员查询',
  revenueAndExpenseQueryWithPagination: '带分页信息的收支查询',
  queryDetails: '查询详情',
  childComponentAccepts: '子组件接受',
  deliveryStaff: '送货员',
  defaultValue: '默认值',
  rule: '规则',
  invalidFormatMessage: '不符合规则时提示信息',
  selectFromDeliveryStaff: '请从送货员中选择',
  deviceLibrary: '设备库',
  selectFromDeviceLibrary: '请从设备库中选择',
  activityName: '活动名称',
  activityDetails: '活动详情',
  discount: '折',
  activityTime: '活动时间',
  isInvalid: '是否失效',
  notInvalid: '未失效',
  invalid: '失效',
  cannotRecoverAfterInvalidation: '失效后将不可恢复',
  confirmInvalidation: '确定失效吗',
  invalidationSuccess: '失效成功',
  invalidate: '失效',
  secondHalfDiscountQueryWithPagination: '带分页信息的查询',
  createOrModify: '创建或修改',
  startTimeCannotBeEarlier: '开始时间不能早于结束时间',
  activityConflict: '存在活动冲突',
  enterActivityName: '请输入活动名称',
  selectStartTime: '请选择开始时间',
  selectEndTime: '请选择结束时间',
  activityCommodities: '活动商品',
  allCommodities: '全部商品',
  partialCommodities: '部分商品',
  singleCommodityOnlyOneActivity: '单个商品仅允许同时参与一个自定义优惠活动',
  selectActivityCommodities: '请选择活动商品',
  deliveryDevices: '投放设备',
  partialDevices: '部分设备',
  selectDeliveryDevices: '请选择投放设备',
  item: '件',
  enterItemNumber: '请输入第件',
  discountRatio: '折扣比例',
  whenMultipleCommoditiesParticipate: '多件商品都参与活动时',
  lowerPriceEnjoysDiscount: '价格低的商品享受折扣优惠',
  'discountCanBe 叠加': '此优惠可循环叠加',
  example: '例',
  ifSetToItem: '若设置的是第件',
  bought: '买了',
  bottleRedBull: '瓶红牛',
  and: '和',
  bottleSprite: '瓶雪碧',
  enjoysDiscount: '则雪碧享受折优惠',
  enterDiscountRatio: '请输入折扣比例',
  coupon: '优惠券',
  publishCouponState: '发布优惠券框状态',
  issuanceDetailsState: '发放详情框状态',
  'anbao xing': '安保兴',
  couponName: '优惠券名称',
  issuedQuantity: '发行数量',
  perPersonLimit: '单人限领',
  couponValidTime: '优惠券生效时间',
  activityStatus: '活动状态',
  normal: '正常',
  expired: '过期',
  fullyRedeemed: '领满',
  doesNotAffectIssued: '此活动失效后不影响已经发放的优惠券使用',
  immediatelyInvalid: '但将立即失效并不可再恢复',
  couponIssuance: '优惠券发放',
  couponUsageDetails: '优惠券使用详情',
  functionUnderConstruction: '功能建设中',
  selectedUsersArray: '选中的用户对象数组',
  selectConsumers: '请选择消费者',
  confirmIssuance: '确认发放优惠券吗',
  enterCouponName: '请输入优惠券名称',
  minimumSpendToUse: '满额可用',
  searchConsumers: '搜索消费者',
  enterFullPhoneNumber: '请输入完整手机号搜索',
  consumers: '名消费者',
  issuancePerPerson: '每人发放数量',
  enterIssuanceQuantity: '请输入发放数量',
  cannotExceedLimit: '发放数量不能大于单人限领数量',
  enterFullPhone: '请输入完整手机号',
  enterValidPhone: '请输入正确的手机号',
  user: '用户',
  username: '用户名',
  userList: '用户列表',
  selectedUsers: '选中的用户',
  passToParent: '回传给父',
  throughMethod: '通过方法中的',
  passToParentComponent: '方法传给父组件',
  createOrModifyCouponActivity: '创建或修改优惠券活动',
  deleteCouponActivity: '删除优惠券活动',
  couponIssuanceUsers: '优惠券发放的用户',
  couponActivity: '优惠券活动',
  viewCouponUsageDetails: '查看优惠券使用详情',
  activityStartTime: '活动开始时间',
  selectActivityStartTime: '请选择活动开始时间',
  activityEndTime: '活动结束时间',
  selectActivityEndTime: '请选择活动结束时间',
  couponEffectiveTime: '优惠券生效时间',
  selectCouponEffectiveTime: '请选择优惠券生效时间',
  couponExpirationTime: '优惠券失效时间',
  selectCouponExpirationTime: '请选择优惠券失效时间',
  couponType: '优惠券类型',
  enterCouponType: '请输入优惠券类型',
  selectCouponType: '请选择优惠券类型',
  receivedAfterOrder: '下单后领取',
  issuedByBackend: '后台发放',
  couponValue: '优惠券面值',
  enterCouponValue: '请输入优惠券面',
  enterMinimumSpendToUse: '请输入满多少元可用',
  minimumSpendToReceive: '满额可领',
  enterMinimumSpendToReceive: '请输入满多少元可领取',
  perPersonLimitTotal: '单人限领总数',
  enterPerPersonLimit: '请输入单人限领总数',
  totalIssuanceQuantity: '发行总数量',
  enterTotalIssuance: '请输入发行总数量',
  getCouponUsageDetails: '获取优惠券使用详情',
  unused: '未使用',
};
